// extracted by mini-css-extract-plugin
export default {"modalBody":"OnboardingChecklistModal_modalBody__10zBh"};